import { IconType } from 'react-icons';
import { FaSms } from 'react-icons/fa';

import Input from './Input';

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
  startIcon?: IconType;
  type?: string;
  placeholdler?: string;
  className?: string;
  value?: string;
}

const SMSInput = (props: InputProps) => (
  <Input
    autofocus
    placeholder="------"
    startIcon={FaSms}
    className={`${props.className}`}
    type="text"
    {...props}
  />
);

export default SMSInput;
